module.exports = __webpack_public_path__ + "media/images/favicons/www-a09ed431a72f8caff538cf82a4523a60e611c5f0bdf8615e3abe01838cc1ad81.ico";